export const EDUZAP_V1ResourcesDE: EDUZAP_V1ResourcesBSInterface = {
  labelDone: "Datum der Aufgabenerledigung",
  errorMissingInput: "Bitte füllen Sie alle Felder aus",
  buttonEdu: "Bildung ausfüllen",
  errors: {
    registerPic: "Das Bild, das Sie hochladen, ist zu groß.",
    recordAlreadyExists:
      "Diese Evidenz wurde bereits ausgefüllt. Sie können sie nicht erneut ausfüllen.",
  },
  input: {
    edu: {
      pickTitle: "Neue Bildung hinzufügen",
      label: "Bildung",
      name: "education",
      placeholder: "Neue Bildung hinzufügen",
    },
    signatureTitle: "Unterschrift",
    datum: {
      label: "Datum",
      placeholder: "Bitte geben Sie das Datum ein",
      name: "datum",
    },
    dokument: {
      label: "Dokument",
      placeholder: "Bitte geben Sie das Dokument ein",
      name: "dokument",
      description: () => (
        <>
          <h4>Dateien hier ablegen oder zum Hochladen klicken.</h4>
          <span className="text-muted font-13">Nur Bilder, max 6MB</span>
        </>
      ),
    },
    cilj: {
      label: "Bildungsziel",
      name: "cilj",
      placeholder: "Bitte geben Sie das Bildungsziel ein",
    },
    izvrsilacObuke: {
      label: "Ausbildungsleiter",
      name: "izvrsilacObuke",
      placeholder: "Bitte geben Sie den Ausbildungsleiter ein",
    },
    radnoMjesto: {
      label: "Arbeitsplatz",
      name: "radnoMjesto",
      placeholder: "Bitte geben Sie den Arbeitsplatz ein",
    },
    mjestoObuke: {
      label: "Ausbildungsort",
      name: "mjestoObuke",
      placeholder: "Bitte geben Sie den Ausbildungsort ein",
    },
    tema: {
      label: "Thema",
      name: "tema",
      placeholder: "Bitte geben Sie das Thema ein",
    },
    verifikacijaEfikasnosti: {
      label: "Effizienzverifizierung",
      name: "verifikacijaEfikasnosti",
      placeholder: "Bitte geben Sie die Effizienzverifizierung ein",
    },
    tipInput: {
      label: "Typ",
      name: "tip",
      placeholder: "Bitte geben Sie den Bildungstyp ein",
    },
    tip: {
      internal: "Interne Bildung",
      external: "Externe Bildung",
      unedefined: "Bitte wählen Sie den Bildungstyp aus",
    },
    verifikacijaEdukatoraPotpis: "Verifizierung - Unterschrift des Ausbilders",
    verifikacijaPrisustvaPotpis: "Verifizierung - Anwesenheitsunterschrift",
  },
  evidencijaForm: {
    buttonForward: "Unterschreiben",
    buttonBack: "Zurück",
  },
  successModal: {
    title: "Dateneingabe",
    body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "Durch die Auswahl der Option Unterschreiben bestätige ich, dass die Aufgabe gemäß den Anweisungen ausgeführt wurde!",
};

interface InputField {
  label: string;
  placeholder: string;
  name: string;
  description?: () => JSX.Element;
}

interface Tip {
  internal: string;
  external: string;
  unedefined: string;
}

interface PickEdu {
  label: string;
  placeholder: string;
  name: string;
  description?: () => JSX.Element;
  pickTitle: string;
}

interface Input {
  edu: PickEdu;
  signatureTitle: string;
  datum: InputField;
  dokument: InputField;
  cilj: InputField;
  izvrsilacObuke: InputField;
  radnoMjesto: InputField;
  mjestoObuke: InputField;
  tema: InputField;
  verifikacijaEfikasnosti: InputField;
  tipInput: InputField;
  tip: Tip;
  verifikacijaEdukatoraPotpis: string;
  verifikacijaPrisustvaPotpis: string;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface EDUZAP_V1ResourcesBSInterface {
  labelDone: string;
  errorMissingInput: string;
  input: Input;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  buttonEdu: string;
  errors: IErrors;
}
